import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBR: CultureInfo = {
  name: 'es-BR',
  displayName: 'español (Brasil)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BR',
  parent: CultureInfoEs
};
